import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 py-12 px-6">
        <div className="container mx-auto max-w-4xl">
          <h1 className="font-heading text-4xl font-bold mb-8" data-testid="privacy-title">Privacy Policy</h1>
          <div className="prose max-w-none space-y-6 text-muted-foreground">
            <p className="text-sm text-muted-foreground"><em>Last Updated: {new Date().toLocaleDateString()}</em></p>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">1. Introduction</h2>
              <p>BC Leads Business Services ("we", "us", "our") operates ScanMyAd. This Privacy Policy explains how we collect, use, and protect your personal data. We comply with:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>PIPEDA (Personal Information Protection and Electronic Documents Act) - Canada</li>
                <li>GDPR (General Data Protection Regulation) - European Union</li>
                <li>CCPA principles - United States (California)</li>
                <li>Indian data protection principles</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">2. Data We Collect</h2>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-2">Account Information:</h3>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Name, email address, password (hashed)</li>
                <li>Payment information (processed by Stripe, not stored by us)</li>
              </ul>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-2 mt-4">Ad Content Data:</h3>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Advertising text, images URLs, landing page URLs, funnel scripts</li>
                <li>Target jurisdiction and platform selections</li>
              </ul>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-2 mt-4">Usage Data:</h3>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Scan history, timestamps, IP addresses</li>
                <li>Browser type, device information</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">3. How We Use Your Data</h2>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li><strong>Service Delivery:</strong> Process compliance scans, generate reports</li>
                <li><strong>AI Processing:</strong> Analyze content using OpenAI GPT-5.2 (via encrypted API calls)</li>
                <li><strong>Account Management:</strong> Authentication, billing, support</li>
                <li><strong>Service Improvement:</strong> Anonymized analytics to improve accuracy</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">4. Data Sharing</h2>
              <p>We do NOT sell or rent your data. We share data only with:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li><strong>Stripe:</strong> Payment processing (PCI DSS compliant)</li>
                <li><strong>OpenAI:</strong> AI analysis (temporary processing, not stored)</li>
                <li><strong>Cloud Infrastructure:</strong> Hosting providers with encryption</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">5. Data Retention</h2>
              <p>We retain data as follows:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Account data: Until account deletion + 30 days</li>
                <li>Scan history: Until account deletion + 30 days</li>
                <li>Billing records: 7 years (tax compliance)</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">6. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Access your personal data</li>
                <li>Correct inaccurate data</li>
                <li>Request data deletion (subject to legal obligations)</li>
                <li>Export your data (JSON format)</li>
                <li>Withdraw consent for data processing</li>
                <li>Lodge complaints with data protection authorities</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">7. Data Security</h2>
              <p>We implement:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>TLS/SSL encryption for data transmission</li>
                <li>Encrypted database storage</li>
                <li>Password hashing (bcrypt)</li>
                <li>Regular security audits</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">8. Cookies</h2>
              <p>We use essential cookies for:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Authentication (session_token)</li>
                <li>Service functionality</li>
              </ul>
              <p className="mt-4">We do NOT use tracking or advertising cookies.</p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">9. International Data Transfers</h2>
              <p>Data may be processed in Canada, United States, or EU. We ensure adequate data protection through:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Standard Contractual Clauses (EU)</li>
                <li>Encryption during transfer</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground mb-4">10. Contact Us</h2>
              <p>For privacy requests or questions:</p>
              <p className="mt-2">
                Email: support@scanmyad.com<br />
                Address: BC Leads Business Services, Unit 108, 13277 108 Avenue, Surrey, BC V3T 0A9, Canada
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
